<template>
  <TvaBackgroundVideo
    class="bg-video-section"
    autoPlay
    :pathToVideo="videoPath"
  />
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import TvaBackgroundVideo from "../general/TvaBackgroundVideo.vue";

const props = defineProps({
  currentPage: String,
  id: String,
});

const i18n = useI18n();

const videoPath = computed(() => {
  const videoNr = props.id.split("-")[props.id.split("-").length - 1];
  return `${props.currentPage}_bg-${i18n.locale.value}-${videoNr}`;
});
</script>

<style lang="scss" scoped>
.bg-video-section {
  width: 100%;
  position: relative;

  .desktop &,
  .large & {
    height: 80vh;
  }

  ::v-deep(video) {
    width: 100%;
    height: auto;

    .tablet &, .mobile & {
      position: relative;
      top: 0;
      left: 0;
      transform: initial;

    }
  }
}
</style>
